export default {
  data:
    [
      {
        "address": "0x4799*********************************0fbb12",
        "num": 9.67
      },
      {
        "address": "0x96b1*********************************3f1b27",
        "num": 4.265
      },
      {
        "address": "0xa4ae*********************************9f6907",
        "num": 7.654
      },
      {
        "address": "0x3b33*********************************290c33",
        "num": 2.357
      },
      {
        "address": "0xe9bb*********************************4e4647",
        "num": 1.232
      },
      {
        "address": "0xd169*********************************037f16",
        "num": 9.87
      },
      {
        "address": "0xb1c3*********************************fbc1ff",
        "num": 2.882
      },
      {
        "address": "0x66b5*********************************163c58",
        "num": 3.667
      },
      {
        "address": "0x46a9*********************************88a717",
        "num": 6.053
      },
      {
        "address": "0x9e2f*********************************9a585d",
        "num": 1.147
      },
      {
        "address": "0xe0a9*********************************b3586f",
        "num": 2.172
      },
      {
        "address": "0xe2b4*********************************e0a9bc",
        "num": 4.562
      },
      {
        "address": "0xf081*********************************b588ea",
        "num": 6.517
      },
      {
        "address": "0xa5ac*********************************94973f",
        "num": 7.15
      },
      {
        "address": "0x655c*********************************dc3a30",
        "num": 8.058
      },
      {
        "address": "0xced5*********************************eb9a93",
        "num": 1.08
      },
      {
        "address": "0x005e*********************************6d3d96",
        "num": 4.149
      },
      {
        "address": "0x4ce8*********************************c099d7",
        "num": 3.679
      },
      {
        "address": "0xfad7*********************************b02d7e",
        "num": 8.52
      },
      {
        "address": "0x460c*********************************f6cc9e",
        "num": 3.339
      },
      {
        "address": "0x06a5*********************************b2d951",
        "num": 8.066
      },
      {
        "address": "0xc4a6*********************************36a451",
        "num": 8.482
      },
      {
        "address": "0x5f59*********************************b1f66d",
        "num": 8.442
      },
      {
        "address": "0x3d24*********************************515e1c",
        "num": 5.725
      },
      {
        "address": "0x8636*********************************6d7151",
        "num": 6.251
      },
      {
        "address": "0x2c81*********************************638cd4",
        "num": 4.626
      },
      {
        "address": "0x6c1e*********************************decf46",
        "num": 3.493
      },
      {
        "address": "0x04a2*********************************754ccd",
        "num": 7.053
      },
      {
        "address": "0x4401*********************************08fbc2",
        "num": 2.141
      },
      {
        "address": "0x07fc*********************************a1f2bf",
        "num": 8.52
      },
      {
        "address": "0x41eb*********************************b0ae3b",
        "num": 3.74
      },
      {
        "address": "0x3d0d*********************************411745",
        "num": 0.538
      },
      {
        "address": "0x802d*********************************064dd8",
        "num": 7.644
      },
      {
        "address": "0xc481*********************************2cd1a8",
        "num": 3.869
      },
      {
        "address": "0x460d*********************************1b3413",
        "num": 1.491
      },
      {
        "address": "0x3170*********************************952eef",
        "num": 9.447
      },
      {
        "address": "0x85ad*********************************423fe2",
        "num": 5.787
      },
      {
        "address": "0x6966*********************************0ba6ed",
        "num": 1.723
      },
      {
        "address": "0x0f75*********************************429647",
        "num": 6.697
      },
      {
        "address": "0xa0c9*********************************3ea117",
        "num": 4.697
      },
      {
        "address": "0x4ac3*********************************29c39d",
        "num": 4.128
      },
      {
        "address": "0x0edf*********************************07d492",
        "num": 6.899
      },
      {
        "address": "0xcaab*********************************726348",
        "num": 3.139
      },
      {
        "address": "0x0d39*********************************467abc",
        "num": 4.245
      },
      {
        "address": "0x73f9*********************************e0a166",
        "num": 6.111
      },
      {
        "address": "0xb833*********************************3568cc",
        "num": 5.325
      },
      {
        "address": "0x136a*********************************67a34a",
        "num": 3.678
      },
      {
        "address": "0xd82b*********************************3deb80",
        "num": 9.569
      },
      {
        "address": "0x02c0*********************************53f706",
        "num": 9.359
      },
      {
        "address": "0xbc69*********************************6b8bb3",
        "num": 4.609
      },
      {
        "address": "0xf1c7*********************************51075d",
        "num": 4.098
      },
      {
        "address": "0x968d*********************************df545d",
        "num": 6.734
      },
      {
        "address": "0x0cf6*********************************1330c4",
        "num": 8.469
      },
      {
        "address": "0x7e1d*********************************8c1905",
        "num": 1.507
      },
      {
        "address": "0x3e57*********************************b0d845",
        "num": 8.537
      },
      {
        "address": "0x48d4*********************************0ea9b8",
        "num": 1.034
      },
      {
        "address": "0x4073*********************************980463",
        "num": 2.245
      },
      {
        "address": "0x4ba5*********************************91af37",
        "num": 9.969
      },
      {
        "address": "0xc203*********************************593997",
        "num": 4.162
      },
      {
        "address": "0x4875*********************************0f86f9",
        "num": 8.11
      },
      {
        "address": "0x4b70*********************************975d07",
        "num": 2.467
      },
      {
        "address": "0xada6*********************************da1cd8",
        "num": 8.118
      },
      {
        "address": "0x0088*********************************cf04d4",
        "num": 9.413
      },
      {
        "address": "0x1a33*********************************d1fbe3",
        "num": 2.205
      },
      {
        "address": "0x6409*********************************10a2cc",
        "num": 2.204
      },
      {
        "address": "0x6d08*********************************a191c1",
        "num": 6.667
      },
      {
        "address": "0xf8b8*********************************3bafd3",
        "num": 0.837
      },
      {
        "address": "0x70d9*********************************941aca",
        "num": 0.265
      },
      {
        "address": "0x0165*********************************22ee9f",
        "num": 7.851
      },
      {
        "address": "0x83af*********************************cf6094",
        "num": 3.088
      },
      {
        "address": "0x9c57*********************************661343",
        "num": 6.65
      },
      {
        "address": "0x3908*********************************28dafe",
        "num": 3.906
      },
      {
        "address": "0x9de5*********************************f6514f",
        "num": 0.733
      },
      {
        "address": "0xb108*********************************368d54",
        "num": 3.903
      },
      {
        "address": "0x57e5*********************************79cb29",
        "num": 8.402
      },
      {
        "address": "0xa940*********************************e36178",
        "num": 4.166
      },
      {
        "address": "0x8332*********************************d46a89",
        "num": 3.473
      },
      {
        "address": "0xc4f4*********************************66d394",
        "num": 1.852
      },
      {
        "address": "0x697c*********************************49ffea",
        "num": 5.292
      },
      {
        "address": "0xa00f*********************************1181ca",
        "num": 3.44
      },
      {
        "address": "0x7e5e*********************************4ce4bb",
        "num": 8.844
      },
      {
        "address": "0x599d*********************************6eac4a",
        "num": 0.979
      },
      {
        "address": "0x09cf*********************************8a9e18",
        "num": 3.542
      },
      {
        "address": "0x5341*********************************b9be93",
        "num": 0.45
      },
      {
        "address": "0x5c30*********************************8199ce",
        "num": 7.621
      },
      {
        "address": "0x2ba1*********************************7bf238",
        "num": 8.592
      },
      {
        "address": "0xcd35*********************************9e44a4",
        "num": 5.115
      },
      {
        "address": "0x722c*********************************57d79f",
        "num": 6.23
      },
      {
        "address": "0x37d4*********************************58957f",
        "num": 0.63
      },
      {
        "address": "0x2347*********************************509192",
        "num": 1.432
      },
      {
        "address": "0xfca2*********************************3300d3",
        "num": 2.947
      },
      {
        "address": "0x3bce*********************************c52d0d",
        "num": 6.667
      },
      {
        "address": "0xb6fc*********************************1d970c",
        "num": 0.038
      },
      {
        "address": "0x21c9*********************************04ac55",
        "num": 3.071
      },
      {
        "address": "0xbada*********************************206dc7",
        "num": 5.65
      },
      {
        "address": "0x491e*********************************e14e1d",
        "num": 1.483
      },
      {
        "address": "0x6eca*********************************c35e79",
        "num": 3.314
      },
      {
        "address": "0xd932*********************************5f9e98",
        "num": 7.225
      },
      {
        "address": "0x05a6*********************************ec19f9",
        "num": 6.132
      },
      {
        "address": "0x9eca*********************************2dfeb0",
        "num": 7.182
      },
      {
        "address": "0x9f19*********************************82a284",
        "num": 2.922
      },
      {
        "address": "0xabc2*********************************f9b9cd",
        "num": 3.373
      },
      {
        "address": "0x34ca*********************************ebade5",
        "num": 6.289
      },
      {
        "address": "0x807e*********************************11f71c",
        "num": 9.959
      },
      {
        "address": "0x4e41*********************************33d0df",
        "num": 9.503
      },
      {
        "address": "0x4117*********************************64c727",
        "num": 4.671
      },
      {
        "address": "0x80e6*********************************ccafba",
        "num": 5.527
      },
      {
        "address": "0x7154*********************************29fca7",
        "num": 1.932
      },
      {
        "address": "0x5ac9*********************************ee2eac",
        "num": 8.094
      },
      {
        "address": "0xb743*********************************a00b3c",
        "num": 3.104
      },
      {
        "address": "0x45ed*********************************38cb38",
        "num": 5.659
      },
      {
        "address": "0xeccd*********************************21afb2",
        "num": 6.728
      },
      {
        "address": "0x85b3*********************************20aeed",
        "num": 0.569
      },
      {
        "address": "0x2cbb*********************************ffdec8",
        "num": 7.767
      },
      {
        "address": "0x441d*********************************ed3a0e",
        "num": 7.835
      },
      {
        "address": "0x8323*********************************5ffefe",
        "num": 7.158
      },
      {
        "address": "0xc863*********************************ee03cf",
        "num": 9.246
      },
      {
        "address": "0x46ca*********************************6a23fd",
        "num": 5.434
      },
      {
        "address": "0x2fb7*********************************a1acef",
        "num": 4.664
      },
      {
        "address": "0x41a1*********************************1225bf",
        "num": 0.665
      },
      {
        "address": "0x12b8*********************************0239a0",
        "num": 0.117
      },
      {
        "address": "0xf664*********************************8c96ce",
        "num": 9.452
      },
      {
        "address": "0x6b3d*********************************62a756",
        "num": 4.753
      },
      {
        "address": "0xbce4*********************************9e4656",
        "num": 0.661
      },
      {
        "address": "0xe518*********************************2ff78a",
        "num": 2.947
      },
      {
        "address": "0x66b7*********************************c31ff6",
        "num": 2.333
      },
      {
        "address": "0xfeb2*********************************97d408",
        "num": 3.124
      },
      {
        "address": "0x73f6*********************************bc4307",
        "num": 0.66
      },
      {
        "address": "0x86bc*********************************3dcc61",
        "num": 4.142
      },
      {
        "address": "0x427e*********************************feb8a6",
        "num": 8.4
      },
      {
        "address": "0x1c10*********************************9610e7",
        "num": 5.692
      },
      {
        "address": "0x526d*********************************e5fb7c",
        "num": 3.221
      },
      {
        "address": "0x7cdd*********************************1e60c8",
        "num": 1.442
      },
      {
        "address": "0x2f85*********************************4bda7f",
        "num": 6.067
      },
      {
        "address": "0x67c9*********************************6dfd17",
        "num": 0.202
      },
      {
        "address": "0x9e21*********************************46d6e2",
        "num": 8.003
      },
      {
        "address": "0x0809*********************************e93422",
        "num": 7.339
      },
      {
        "address": "0xca4d*********************************9fbcfb",
        "num": 5.116
      },
      {
        "address": "0x7ea4*********************************f8168a",
        "num": 0.078
      },
      {
        "address": "0xdfc2*********************************6a2983",
        "num": 1.241
      },
      {
        "address": "0xfe3f*********************************bdd51f",
        "num": 0.373
      },
      {
        "address": "0xf765*********************************557e2d",
        "num": 8.075
      },
      {
        "address": "0xfeb8*********************************ada11c",
        "num": 0.928
      },
      {
        "address": "0x0940*********************************f2db77",
        "num": 4.676
      },
      {
        "address": "0xdb76*********************************c97377",
        "num": 2.917
      },
      {
        "address": "0xfb18*********************************6843c2",
        "num": 2.241
      },
      {
        "address": "0x3a8b*********************************a93d49",
        "num": 5.192
      },
      {
        "address": "0xeb19*********************************a4b16a",
        "num": 3.678
      },
      {
        "address": "0xf2b2*********************************c1d169",
        "num": 6.039
      },
      {
        "address": "0x3f40*********************************93509a",
        "num": 6.88
      },
      {
        "address": "0xa852*********************************6e0b84",
        "num": 6.226
      },
      {
        "address": "0x6ce7*********************************90aec9",
        "num": 5.817
      },
      {
        "address": "0xe116*********************************b3d928",
        "num": 9.696
      },
      {
        "address": "0x8d23*********************************efc65d",
        "num": 8.72
      },
      {
        "address": "0x045d*********************************e91ecf",
        "num": 4.667
      },
      {
        "address": "0xea04*********************************70f377",
        "num": 4.586
      },
      {
        "address": "0x1735*********************************d168b6",
        "num": 9.677
      },
      {
        "address": "0xe48b*********************************7c7281",
        "num": 5.668
      },
      {
        "address": "0x0032*********************************1ac840",
        "num": 3.54
      },
      {
        "address": "0x2436*********************************380029",
        "num": 1.093
      },
      {
        "address": "0x21fa*********************************07db20",
        "num": 7
      },
      {
        "address": "0xf3c2*********************************a05813",
        "num": 8.666
      },
      {
        "address": "0xd959*********************************0d1795",
        "num": 0.181
      },
      {
        "address": "0x6ee3*********************************399e89",
        "num": 1.135
      },
      {
        "address": "0xee12*********************************d40db7",
        "num": 2.086
      },
      {
        "address": "0x07fc*********************************70c3bd",
        "num": 4.28
      },
      {
        "address": "0x9d0a*********************************d0cb06",
        "num": 2.459
      },
      {
        "address": "0x5fce*********************************a03f0f",
        "num": 4.666
      },
      {
        "address": "0x0e06*********************************1543be",
        "num": 5.005
      },
      {
        "address": "0xf7e1*********************************1821a9",
        "num": 1.972
      },
      {
        "address": "0x78bf*********************************4c178a",
        "num": 1.126
      },
      {
        "address": "0x37db*********************************c50490",
        "num": 1.358
      },
      {
        "address": "0xda5e*********************************547afb",
        "num": 2.815
      },
      {
        "address": "0xba7e*********************************a11e52",
        "num": 2.044
      },
      {
        "address": "0xa277*********************************f53c21",
        "num": 9.808
      },
      {
        "address": "0x862a*********************************58028b",
        "num": 6.96
      },
      {
        "address": "0x188a*********************************6b1570",
        "num": 9.822
      },
      {
        "address": "0x5cf1*********************************113bc0",
        "num": 4.615
      },
      {
        "address": "0x3272*********************************b36efe",
        "num": 3.318
      },
      {
        "address": "0x8854*********************************1b3c67",
        "num": 7.002
      },
      {
        "address": "0x98e2*********************************b001a0",
        "num": 4.866
      },
      {
        "address": "0x26bc*********************************1e84d4",
        "num": 6.217
      },
      {
        "address": "0x126d*********************************8ebcf4",
        "num": 5.03
      },
      {
        "address": "0xe5fb*********************************807e9e",
        "num": 7.998
      },
      {
        "address": "0xde13*********************************f41123",
        "num": 8.45
      },
      {
        "address": "0x15a6*********************************588011",
        "num": 4.556
      },
      {
        "address": "0xc201*********************************c353f1",
        "num": 7.657
      },
      {
        "address": "0x5fa5*********************************ddb95b",
        "num": 5.742
      },
      {
        "address": "0x8e82*********************************adfffc",
        "num": 5.967
      },
      {
        "address": "0xec9b*********************************c015bd",
        "num": 8.135
      },
      {
        "address": "0x4557*********************************4557db",
        "num": 6.819
      },
      {
        "address": "0x5dfa*********************************128553",
        "num": 8.162
      },
      {
        "address": "0x1caf*********************************f573c3",
        "num": 6.409
      },
      {
        "address": "0xc8dc*********************************512aea",
        "num": 8.45
      },
      {
        "address": "0x4bd5*********************************7b4f63",
        "num": 4.597
      },
      {
        "address": "0xe866*********************************0b2ef1",
        "num": 0.19
      },
      {
        "address": "0x7591*********************************c60f1b",
        "num": 5.203
      },
      {
        "address": "0xaf84*********************************a065e1",
        "num": 6.765
      },
      {
        "address": "0x25b0*********************************d5abf7",
        "num": 6.046
      },
      {
        "address": "0x3dc6*********************************551cec",
        "num": 5.143
      },
      {
        "address": "0xcf73*********************************15a836",
        "num": 4.62
      },
      {
        "address": "0x3696*********************************6dd491",
        "num": 3.246
      },
      {
        "address": "0x0743*********************************5adf2c",
        "num": 7.504
      },
      {
        "address": "0xaedf*********************************243de9",
        "num": 9.067
      },
      {
        "address": "0xd6c0*********************************8673b3",
        "num": 0.999
      },
      {
        "address": "0xefec*********************************b10990",
        "num": 7.524
      },
      {
        "address": "0x03cc*********************************ce7376",
        "num": 8.801
      },
      {
        "address": "0x7193*********************************475059",
        "num": 6.436
      },
      {
        "address": "0x89cd*********************************6e55bc",
        "num": 6.591
      },
      {
        "address": "0x8327*********************************f134f0",
        "num": 5.566
      },
      {
        "address": "0xf455*********************************85902a",
        "num": 9.271
      },
      {
        "address": "0x63e1*********************************1d15a5",
        "num": 1.214
      },
      {
        "address": "0xdc3e*********************************335b8c",
        "num": 3.78
      },
      {
        "address": "0x398e*********************************926249",
        "num": 1.38
      },
      {
        "address": "0x1f18*********************************047205",
        "num": 9.106
      },
      {
        "address": "0xc9cb*********************************e5f719",
        "num": 1.106
      },
      {
        "address": "0x716c*********************************75e1d4",
        "num": 4.01
      },
      {
        "address": "0x5583*********************************6df79a",
        "num": 2.834
      },
      {
        "address": "0x3f0b*********************************485b87",
        "num": 4.696
      },
      {
        "address": "0x45bf*********************************98f456",
        "num": 3.062
      },
      {
        "address": "0x0650*********************************23e5d2",
        "num": 9.687
      },
      {
        "address": "0xf40e*********************************204339",
        "num": 0.76
      },
      {
        "address": "0x0e9b*********************************a4d129",
        "num": 3.412
      },
      {
        "address": "0x17a5*********************************176f6e",
        "num": 6.362
      },
      {
        "address": "0x8087*********************************857f7f",
        "num": 1.118
      },
      {
        "address": "0x2f35*********************************2a63eb",
        "num": 1.273
      },
      {
        "address": "0x8a28*********************************6cdcd5",
        "num": 7.414
      },
      {
        "address": "0x1748*********************************b9121f",
        "num": 6.816
      },
      {
        "address": "0x2a46*********************************ffea00",
        "num": 8.334
      },
      {
        "address": "0x293b*********************************246d0e",
        "num": 8.314
      },
      {
        "address": "0x6764*********************************4d6307",
        "num": 2.682
      },
      {
        "address": "0x0ce6*********************************c328f9",
        "num": 4.037
      },
      {
        "address": "0x29e8*********************************0c2fab",
        "num": 1.995
      },
      {
        "address": "0x24ad*********************************ecfef4",
        "num": 4.389
      },
      {
        "address": "0xe01c*********************************55e0ce",
        "num": 2.954
      },
      {
        "address": "0x65fb*********************************a8853f",
        "num": 9.596
      },
      {
        "address": "0xdd8d*********************************87f275",
        "num": 3.304
      },
      {
        "address": "0xfbdd*********************************76baaf",
        "num": 9.513
      },
      {
        "address": "0x802e*********************************06e0fb",
        "num": 4.626
      },
      {
        "address": "0xb608*********************************60d1da",
        "num": 1.032
      },
      {
        "address": "0x762e*********************************2f519b",
        "num": 6.413
      },
      {
        "address": "0xc94e*********************************a8e1b6",
        "num": 7.109
      },
      {
        "address": "0xfbf2*********************************99978a",
        "num": 0.753
      },
      {
        "address": "0x12d8*********************************4e5c9f",
        "num": 2.94
      },
      {
        "address": "0x1b2f*********************************ed8f57",
        "num": 8.683
      },
      {
        "address": "0x6896*********************************9fc196",
        "num": 3.974
      },
      {
        "address": "0x68e0*********************************fc03e7",
        "num": 8.47
      },
      {
        "address": "0xbfb1*********************************d9e14b",
        "num": 6.237
      },
      {
        "address": "0x287b*********************************0348e4",
        "num": 9.843
      },
      {
        "address": "0x0972*********************************0e0dd0",
        "num": 8.127
      },
      {
        "address": "0x08c7*********************************7d3397",
        "num": 5.773
      },
      {
        "address": "0x9bcb*********************************737531",
        "num": 3.664
      },
      {
        "address": "0x5917*********************************575b52",
        "num": 6.376
      },
      {
        "address": "0x8548*********************************a2bd57",
        "num": 5.187
      },
      {
        "address": "0x053d*********************************7734a2",
        "num": 0.669
      },
      {
        "address": "0xafc2*********************************12415e",
        "num": 7.458
      },
      {
        "address": "0xe9d4*********************************94bf11",
        "num": 2.471
      },
      {
        "address": "0x0117*********************************25c86a",
        "num": 9.949
      },
      {
        "address": "0x8e24*********************************70b557",
        "num": 5.812
      },
      {
        "address": "0x803f*********************************ed6a06",
        "num": 6.573
      },
      {
        "address": "0x8c6d*********************************cec704",
        "num": 9.711
      },
      {
        "address": "0x4b15*********************************a4da23",
        "num": 7.236
      },
      {
        "address": "0x5c64*********************************b93968",
        "num": 1.985
      },
      {
        "address": "0x4aa9*********************************74b584",
        "num": 6.101
      },
      {
        "address": "0x5c35*********************************3f1185",
        "num": 1.291
      },
      {
        "address": "0x4b00*********************************d785e8",
        "num": 0.045
      },
      {
        "address": "0x588c*********************************c20663",
        "num": 1.797
      },
      {
        "address": "0x6561*********************************26e4ec",
        "num": 6.126
      },
      {
        "address": "0x279e*********************************dc1a47",
        "num": 0.138
      },
      {
        "address": "0x344b*********************************daf528",
        "num": 3.557
      },
      {
        "address": "0xfc18*********************************d2c8b6",
        "num": 1.043
      },
      {
        "address": "0x864b*********************************67ae59",
        "num": 6.741
      },
      {
        "address": "0x3ba0*********************************8f30ca",
        "num": 2.653
      },
      {
        "address": "0xd43e*********************************b5fefc",
        "num": 8.159
      },
      {
        "address": "0x23ce*********************************96e691",
        "num": 6.974
      },
      {
        "address": "0xc5c1*********************************6c67cc",
        "num": 9.205
      },
      {
        "address": "0xad0c*********************************56ee88",
        "num": 5.992
      },
      {
        "address": "0xabbd*********************************b61690",
        "num": 9.889
      },
      {
        "address": "0x6976*********************************e45890",
        "num": 9.424
      },
      {
        "address": "0x55fe*********************************123683",
        "num": 5.195
      },
      {
        "address": "0xdd26*********************************bd4685",
        "num": 4.55
      },
      {
        "address": "0xd52b*********************************2b6a9a",
        "num": 6.482
      },
      {
        "address": "0x88c1*********************************9c9712",
        "num": 2.081
      },
      {
        "address": "0xa0be*********************************f5ad1d",
        "num": 4.31
      },
      {
        "address": "0xe5e7*********************************69c806",
        "num": 9.711
      },
      {
        "address": "0xc300*********************************6ef2c9",
        "num": 1.087
      },
      {
        "address": "0x0a77*********************************c53be5",
        "num": 4.662
      },
      {
        "address": "0x67cf*********************************1653ee",
        "num": 0.145
      },
      {
        "address": "0xb827*********************************02124a",
        "num": 9.938
      },
      {
        "address": "0x3c94*********************************4c9958",
        "num": 0.598
      },
      {
        "address": "0x9dc5*********************************f00eb5",
        "num": 7.856
      },
      {
        "address": "0x0e0e*********************************339459",
        "num": 0.604
      },
      {
        "address": "0x719d*********************************b13249",
        "num": 2.664
      },
      {
        "address": "0x5dac*********************************a8270c",
        "num": 1.312
      },
      {
        "address": "0xb3c8*********************************6857b4",
        "num": 8.382
      },
      {
        "address": "0x4000*********************************399a9e",
        "num": 1.02
      },
      {
        "address": "0xc848*********************************d24801",
        "num": 3.613
      },
      {
        "address": "0x3f7c*********************************25e81f",
        "num": 9.877
      },
      {
        "address": "0x4a1d*********************************a3236e",
        "num": 3.548
      },
      {
        "address": "0xa042*********************************586578",
        "num": 4.785
      },
      {
        "address": "0xca81*********************************dc8379",
        "num": 3.957
      },
      {
        "address": "0x503b*********************************0db440",
        "num": 4.555
      },
      {
        "address": "0x9977*********************************726b68",
        "num": 3.623
      },
      {
        "address": "0xcac2*********************************262c7a",
        "num": 3.579
      },
      {
        "address": "0x3255*********************************8ee7ce",
        "num": 2.452
      },
      {
        "address": "0x397a*********************************b5f72e",
        "num": 7.637
      },
      {
        "address": "0xddff*********************************69b8b3",
        "num": 2.533
      },
      {
        "address": "0x344e*********************************2d7920",
        "num": 4.156
      },
      {
        "address": "0x4768*********************************05a2aa",
        "num": 8.974
      }
    ]
}